import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ButtonPrimary } from '@americanexpress/dls-react';
import ReviewPage from './ReviewPage';
import useDocumentTitle from '../../helper/documentTitle';
import InformationEditPage from './InformationEditPage';
import * as interfaceJournalDataService from '../../services/interfaceJournalDataService';
import Loading from '../Util/Loading';
import ErrorBoundary from '../Util/ErrorBoundary';
import SuccessPage from './SuccessPage';

const PageDisplay = (page, content) => {
  switch (page) {
    case 1:
      return content;
    case 2:
      return <SuccessPage />;
    case -1:
      return <ErrorBoundary />;
    default:
      return content;
  }
};

const ExternalVendorReview = () => {
  useDocumentTitle('Supplier Information Review');
  const oracleVendorId = useParams().recId;
  const [isLoading, setIsLoading] = useState(true);
  const [isReviewPage, setIsReviewPage] = useState(true);
  const [page, setPage] = useState(1);
  const [formData, setFormData] = useState({
    supplierFirstName: '',
    supplierLastName: '',
    supplierPhoneNo: '',
    supplierEmail: '',
  });

  useEffect(() => {
    (async () => {
      await interfaceJournalDataService
        .getOracleVendor(oracleVendorId)
        .then((res) => {
          setIsLoading(false);
          setFormData({
            ...formData,
            supplierFirstName: res.data?.supplierFirstName,
            supplierLastName: res.data?.supplierLastName,
            supplierPhoneNo: res.data?.supplierPhoneNo,
            supplierEmail: res.data?.supplierEmail,
          });
        });
    })();
  }, []);

  const reviewOrEditElement = isReviewPage ? (
    <ReviewPage formData={formData} />
  ) : (
    <InformationEditPage formData={formData} setFormData={setFormData} />
  );

  const editInformation = () => {
    setIsReviewPage(!isReviewPage);
  };

  const editButtonText = isReviewPage ? 'Edit Information' : 'Save Changes';

  const updateOracleSupplier = async () => {
    const oracleSupplierData = {
      oracleRecordId: oracleVendorId,
      supplierFirstName: formData.supplierFirstName,
      supplierLastName: formData.supplierLastName,
      supplierPhoneNo: formData.supplierPhoneNo,
      supplierEmail: formData.supplierEmail,
    };

    await interfaceJournalDataService
      .updateOracleVendor(oracleSupplierData)
      .then((res) => setPage(2))
      .catch((err) => setPage(-1));
  };

  const submitButtonElement = isReviewPage ? (
    <ButtonPrimary className="margin-1-r" onClick={updateOracleSupplier}>
      Submit
    </ButtonPrimary>
  ) : (
    <div />
  );

  const content = isLoading ? (
    <Loading />
  ) : (
    <div className="col-xs-12 col-md-12 col-lg-5 margin-responsive pad-0">
      {reviewOrEditElement}
      <div className="new-line" />
      <ButtonPrimary
        className="margin-1-r margin-2-l"
        onClick={editInformation}
      >
        {editButtonText}
      </ButtonPrimary>
      {submitButtonElement}
    </div>
  );

  return PageDisplay(page, content);
};

export default ExternalVendorReview;
